import * as DialogContract from '@tableau/dialog-api-contract';
import * as React from 'react';
import * as widgets from '@tableau/widgets';

export class DialogContractWidget extends React.Component<DialogContract.DialogContractProps, {}>
  implements DialogContract.DialogContractWidget {
  public render(): JSX.Element {
    let dialogProps: widgets.DialogProps = {
      testId: this.props.testId,
      isModal: this.props.isModal,
      // transparent by default to match Desktop behavior.
      isGlassTransparent: true,
      type:
        this.props.showTitleBar || this.props.showTitleBar === undefined
          ? widgets.DialogType.NormalWithTitleBar
          : widgets.DialogType.NormalWithoutTitleBar,
      showCloseButton: true,
      title: this.props.title,
      positioningBehavior: widgets.DialogPositioningBehavior.Draggable,
      shouldAdjustPositionOnWindowResize: true,
      zIndex: 988,
      dialogWidth: this.props.dialogWidth,
      showFooter: false,
      onCloseRequest: this.props.onCloseRequest,
      dialogBodyStyle: { overflow: 'visible', ...this.props.dialogBodyStyle },
      children: this.props.children
    };
    return <widgets.DialogWidget {...dialogProps} />;
  }
}

/**
 * @deprecated to be removed.
 */
export class DialogWidget extends DialogContractWidget implements DialogContract.DialogWidget {}



// WEBPACK FOOTER //
// ../../src/DialogAPIContract.tsx